module.exports = __webpack_public_path__ + "img/ring_y_i_1_0@3x.93d6116f.png";